export const medlineCopy = {
  codeLabel: "NE1 Code"
};

export const defaultCopy = {
  codeLabel: "Swift Code"
};
